/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Pro_TitleInputs */

const en_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plant<span style="[%2$s]"> Plus Exclusive Trees &amp; Real Trees </span>for the Earth!</span>`)
};

const ar_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> ازرع <span style="[%2$s]">أشجار بلس الحصرية وأشجار حقيقية </span> من أجل الأرض! </span>`)
};

const de_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Pflanzen<span style="[%2$s]"> Plus Exklusive Bäume &amp; Echte Bäume </span>für die Erde!</span>`)
};

const es_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Planta<span style="[%2$s]"> árboles exclusivos Plus y árboles reales </span>para la Tierra</span>`)
};

const fr_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plantez<span style="[%2$s]"> des arbres exclusifs Plus &amp; de véritables arbres</span>pour la Terre !</span>`)
};

const it_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> Pianta <span style="[%2$s]">più alberi esclusivi e alberi veri</span> per la Terra! </span>`)
};

const ja_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Plus限定樹種＆本物の木</span>を地球のために植えよう！</span>`)
};

const ko_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">지구를 위해 <span style="[%2$s]">Plus 전용 나무와 실제 나무</span>를 심으세요!</span>`)
};

const pt_br_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plante <span style="[%2$s]">Árvores exclusivas Plus &amp; árvores reais</span> pela Terra!</span>`)
};

const ru_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> Сажайте <span style="[%2$s]"> эксклюзивные растения Plus и настоящие деревья </span>для Земли!</span>`)
};

const th_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">ปลูก<span style="[%2$s]">ต้นไม้สุดพิเศษเฉพาะ Plus และต้นไม้จริงเพิ่มเติม</span>ให้กับโลก!</span>`)
};

const tr_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Dünya için<span style="[%2$s]"> Plus Özel Ağaçları &amp; Gerçek Ağaçlar </span>Dik!</span>`)
};

const zh_cn_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus 独享树种随你种，还能为地球<span style="[%2$s]">种树减碳</span>！</span>`)
};

const zh_tw_subscription_walkthrough_p1_pro_title = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus 獨享樹種隨你種，還能為地球<span style="[%2$s]">種樹減碳</span>！</span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">Plant<span style=\"[%2$s]\"> Plus Exclusive Trees &amp; Real Trees </span>for the Earth!</span>" |
*
* @param {Subscription_Walkthrough_P1_Pro_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_pro_title = /** @type {((inputs?: Subscription_Walkthrough_P1_Pro_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Pro_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_pro_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_pro_title(inputs)
	return zh_tw_subscription_walkthrough_p1_pro_title(inputs)
});